import styles from "./styles.module.css"
import { useState } from "react";
import InputText from "../../Form/InputText";


import { database,storage } from "../../../services/firebase-config";

import { addDoc, updateDoc, doc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"

import Loading from "../../Loading";
import InputFileImageChangeBgColor from "../../Form/InputFileImageChangeBgColor";


export default function ModalCreateUpdateQuestion({ setModal, collectionRef, categoryData, update, updateTableData }) {


    const [name, setName] = useState(categoryData ? categoryData.name ? categoryData.name : '' : '');
    const [color, setColor] = useState(categoryData ? categoryData.color ? categoryData.color : '' : '');
    const [image, setImage] = useState(categoryData ? categoryData.image ? categoryData.image : '' : '');
  

    const [isLoading, setIsLoading] = useState(false)

    async function updateCategory(event) {
        event.preventDefault();
        setIsLoading(true);

        const docRef = doc(database, 'categories', categoryData.id);

        const collectionName = collectionRef.id;

        let imageUrl = '';

        if (image.name) {
            const storageImageRef = ref(storage, `images/${collectionName}/${categoryData.id}`);
            await uploadBytes(storageImageRef, image);
            imageUrl = await getDownloadURL(storageImageRef);
        }
        else {
            imageUrl = image;
        }
        

        updateDoc(docRef, {
            color:color,
            image:imageUrl,
            name:name,
        })

        setModal(false)
        setIsLoading(false);

        updateTableData();

    }


    async function createCategory(event) {
        event.preventDefault();
        setIsLoading(true);
        const newDoc = await addDoc(collectionRef, {
            active: true,
            color:color,
            name:name,
          
        });

        const collectionName = collectionRef.id;

        let imageUrl = 'https://i.pinimg.com/736x/28/03/4e/28034e601b054650d3a70e382db80b44.jpg';
        if (image) {
            const storageImageRef = ref(storage, `images/${collectionName}/${newDoc.id}`);
            await uploadBytes(storageImageRef, image);
            imageUrl = await getDownloadURL(storageImageRef);
        }


        updateDoc(newDoc, { id: newDoc.id, image:imageUrl, })

        setModal(false);
        setIsLoading(false);
        updateTableData();
    }

    return (
        <div className={styles.fixed}>
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2>{update ? 'Atualizar Categoria' : 'Criar Categoria'}</h2>

                    <form>
                        <InputText value={name} name="Nome" setValue={setName} type="text" />
                        <InputText value={color} name="Cor" setValue={setColor} type="color" />
                        <InputFileImageChangeBgColor value={image} setValue={setImage} bookData={categoryData} bgColor={color} />   
                    </form>

                    <div className={styles.buttonsContainer}>
                        <button className={styles.modalCard__closeButton} onClick={() => { setModal(false) }}>Fechar</button>
                        {
                            update
                                ?
                                <button onClick={(event) => { updateCategory(event) }} className={styles.modalCard__saveButton}>Atualizar</button>
                                :
                                <button onClick={(event) => { createCategory(event) }} className={styles.modalCard__saveButton}>Criar</button>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}